import { render, staticRenderFns } from "./TaskCenter.vue?vue&type=template&id=a97ad098&scoped=true&"
import script from "./TaskCenter.vue?vue&type=script&lang=js&"
export * from "./TaskCenter.vue?vue&type=script&lang=js&"
import style0 from "./TaskCenter.vue?vue&type=style&index=0&id=a97ad098&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97ad098",
  null
  
)

export default component.exports